<template>
    <div class="nav-link" :class="classes" @click="actionClick">
        <img src="../../assets/images/grid-icon.svg" alt="Grid Icon">
        <span v-text="name"></span>
    </div>
</template>

<script>
    export default {
        name: "NavLink",
        props: {
            name: {
                type: String,
                required: true,
            },
            path: {
                type: String,
                required: true,
            },
            iconName: {
                type: String,
                required: true,
            },
        },
        computed: {
            iconUrl() {
                return require('@/assets/' + this.iconName + '.svg');
            },
            active() {
                return this.$route.path === this.path;
            },
            classes() {
                return {
                    'active': this.active
                }
            }
        },
        methods: {
            actionClick() {
                this.$router.push(this.path);
            }
        }
    }
</script>